export default "__VITE_ASSET__aa604419__"